/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class EquipmentTemplateField {
    constructor() {
        this.authorizedValues = [];
    }
}

export {EquipmentTemplateField};



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/EquipmentTemplateField.js